import React from 'react';
import { TranslatedValue } from '../../../../domain/models/ApiClient';
import { StatusBadge } from '../../../../../../shared/components/ui/StatusBadge';

interface ApiClientStatusChipProps {
  status: TranslatedValue;
}

/**
 * ApiClientStatusChip
 * Badge de estado para API clients
 * Alineado con Stitch: Nexus Admin design system
 */
export const ApiClientStatusChip: React.FC<ApiClientStatusChipProps> = ({ status }) => {
  // Map status keys to StatusBadge status types
  const statusMap: Record<string, 'active' | 'suspended' | 'revoked' | 'pending'> = {
    active: 'active',
    suspended: 'suspended',
    revoked: 'revoked',
    pending: 'pending',
  };

  const badgeStatus = statusMap[status.key] ?? 'pending';

  return <StatusBadge label={status.value} status={badgeStatus} />;
};
